import MyBookings from "./MyBookings";

export default MyBookings;
